import { getModule } from 'vuex-module-decorators'
import store from '@/store'
import modules from '@/store/modules'
import * as types from '@/@types/store'

export const browser: types.browser = getModule(modules.browser, store)
export const files: types.files = getModule(modules.files, store)
export const root: types.root = getModule(modules.root, store)
export const survey: types.survey = getModule(modules.survey, store)
export const user: types.userDetails = getModule(modules.user, store)